import React from 'react'
import { AnchorLink } from 'gatsby-plugin-anchor-links'
import classNames from 'classnames'

import ColorChar from 'src/components/ColorChar'

import styles from './styles.module.scss'

const About = () => {
    const partnershipWrapClass = classNames(styles.wrapper, styles.partnership)

    return (
        <section className={styles.about}>
            <div id="home" className="container">
                <div className={styles.wrapper}>
                    <div className={styles.freshDesign}>
                        <h1 id="h1" className={styles.title}>
                            You dream it. <br /> We <span className={styles.green}>design</span>{' '}
                            <ColorChar>it</ColorChar>
                        </h1>
                        <p className={styles.freshDesignText}>
                            Reimagine your business potential with world-class branding, design, and
                            digital marketing solutions. Stand out from the crowd with stunning
                            design.
                        </p>
                    </div>
                    <AnchorLink to="/#contact" className={styles.request}>
                        Leave request
                    </AnchorLink>
                </div>
                <div id="about" className={partnershipWrapClass}>
                    <div>
                        <h2 className={styles.subtitle}>
                            We solve complex problems <ColorChar>with</ColorChar> <br />{' '}
                            cutting-edge creative.{' '}
                        </h2>
                        <p>
                            We help brands craft a cohesive visual identity that ignites brand
                            recognition and inspires action in audiences. With captivating design,
                            powerful branding, and world-class digital marketing solutions.
                        </p>
                        <p>
                            Calaton Studio serves as your partner to drive impact through strategic
                            creativity.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default About
